module.exports = __webpack_public_path__ + "img/53.1.4a9f840e.jpg";